import { render, staticRenderFns } from "./wechatpay.vue?vue&type=template&id=7a40e321&scoped=true"
import script from "./wechatpay.vue?vue&type=script&lang=js"
export * from "./wechatpay.vue?vue&type=script&lang=js"
import style0 from "./wechatpay.vue?vue&type=style&index=0&id=7a40e321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a40e321",
  null
  
)

export default component.exports